import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Mock mock delay function
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const login = createAsyncThunk(
  'auth/login',
  async ({ username, password }, { rejectWithValue }) => {
    await delay(800); // simulate network delay
    
    // Hardcoded mock authentication
    if (password !== 'password123') {
      return rejectWithValue({ detail: 'Invalid credentials. Use password123' });
    }

    let role = 'EMPLOYEE';
    if (username.includes('admin')) {
      role = 'ADMIN';
    } else if (username.includes('employer')) {
      role = 'EMPLOYER';
    }

    const mockToken = 'mock-jwt-token-' + Date.now();
    localStorage.setItem('access_token', mockToken);
    localStorage.setItem('user_role', role);
    
    return { token: mockToken, role: role };
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    role: localStorage.getItem('user_role') || null,
    token: localStorage.getItem('access_token'),
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user_role');
      state.user = null;
      state.role = null;
      state.token = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.role = action.payload.role;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
